import { render, staticRenderFns } from "./table.vue?vue&type=template&id=0c1dbad3&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=0c1dbad3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1dbad3",
  null
  
)

export default component.exports